import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { companyJobfeedAutoCompleteInput$, companyJobfeedAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const CompanyBroadMatchAutoSuggest = renderAutoSuggestWithOptions(
   companyJobfeedAutoCompleteObservable$,
   companyJobfeedAutoCompleteInput$,
);

CompanyBroadMatchAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Company Matches',
};

export default CompanyBroadMatchAutoSuggest;
